<template>
    <div class="col-12 nopads">
        <admin-top-bar
                @showUsers="showUserView"
                @showOrganizations="showOrganizationView"/>
        <alert
                :show="alertVisible"
                :message="message"
                :variant="variant"
                @alertShown=alertShown
        />
        <div class="col-12 main-container">
            <div class="col-xl-10 content-container mx-auto">
                <transition name="fade">
                    <div class="mx-auto mt-6 mb-6">
                        <keep-alive>
                            <organizations
                                    v-if="organizationView"
                                    :stripe-auth-code="stripeAuthCode"
                                    @alert="showAlert"/>
                        </keep-alive>
                        <keep-alive>
                            <users
                                    v-if="userView"
                                    @alert="showAlert"/>
                        </keep-alive>
                    </div>
                </transition>
            </div>
            <footer-area />
        </div>
    </div>
</template>

<script>
    import Organizations from '../components/organization/Organizations'
    import Users from '../components/user/Users'
    import {alertMixin} from '../mixins/AlertMixin'
    import Alert from '../components/Alert'
    import AdminTopBar from "../components/AdminTopBar"
    import FooterArea from "@/components/FooterArea";

    export default {
        name: 'admin-view',
        mixins: [alertMixin],
        components: {
            FooterArea,
            AdminTopBar,
            Alert, Organizations, Users
        },
        data() {
            return {
                organizationView: true,
                userView: false,
                stripeAuthCode: null
            }
        },
        mounted() {
            this.checkStripeRedirect()
        },
        methods: {
            showOrganizationView() {
                this.organizationView = true
                this.userView = false
            },

            showUserView() {
                this.organizationView = false
                this.userView = true
            },
            checkStripeRedirect() {
                let code = this.$route.query.code
                let error = this.$route.query.error_description
                if (code) {
                    this.stripeAuthCode = code
                } else if (error) {
                    this.showAlert(this.$t('payment.stripe_account_error'), 'danger')
                    setTimeout(this.reload, 3000)
                }
            },

            reload() {
                window.location.href = window.location.href.split("?")[0]
            }
        }
    }
</script>